import styled from 'styled-components';

export const Test = styled.div`
  display: flex;
  justify-content: space-around;
`;
